import { ImageTransform } from '@/types/image'

import { CropCoordinates } from '../types'

export const setCropCoordinates = (
  transform: ImageTransform,
  coordinates: CropCoordinates
) => {
  transform.crop_h = coordinates.crop_h
  transform.crop_w = coordinates.crop_w
  transform.crop_x = coordinates.crop_x
  transform.crop_y = coordinates.crop_y
}
